export enum CallState {
  COMPLETE = 'Complete',
  ONGOING = 'Ongoing',
  INITIATED = 'Initiated',
  READY = 'Ready',
  ERROR = 'Error',
}
